import { render, staticRenderFns } from "./copyTemplateDialog.vue?vue&type=template&id=885fb076&"
import script from "./copyTemplateDialog.vue?vue&type=script&lang=js&"
export * from "./copyTemplateDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports